declare global {
  interface Window {
    Telegram?: {
      WebApp: TelegramWebApp;
    };
  }
}

interface TelegramWebApp {
  initData: string;
  initDataUnsafe: {
    user?: { id: number; first_name: string; username?: string };
    auth_date: number;
    hash: string;
  };
  ready(): void;
  close(): void;
  expand(): void;
  MainButton: { text: string; show(): void; hide(): void; onClick(fn: () => void): void };
  BackButton: { show(): void; hide(): void; onClick(fn: () => void): void };
  HapticFeedback: { impactOccurred(style: string): void; notificationOccurred(type: string): void };
  themeParams: Record<string, string>;
  colorScheme: 'light' | 'dark';
}

export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function getInitData(): string {
  return getTelegramWebApp()?.initData ?? '';
}
